
import { mapGetters } from "vuex";

export default {
  components: {
    ChevronDownIcon: () =>
      import("~/assets/svg/heroicons/chevron-down.svg?inline=1"),
  },
  data() {
    return {
      scrolled: 0,
    };
  },
  computed: {
    ...mapGetters({
      hasGeometries: "aboutmenu/getGeometries",
      hasManuals: "aboutmenu/getManuals",
    }),
  },
  beforeMount() {
    if (process.browser) {
      window.addEventListener("scroll", this.handleScroll, false);
    }
  },
  beforeDestroy() {
    if (process.browser) {
      window.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    handleScroll() {
      this.scrolled = window.pageYOffset !== undefined ? window.scrollY : "";
    },
  },
};
